export default {
      id: "max-group-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "app/svg/sprite.svg#max-group",
      toString: function () {
        return this.url;
      }
    }